import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import GroupRefundTravelRepository from '@/shared/http/repositories/configuration/grouprefundtravel.js'
import GroupRefundTravelModel from '@/shared/models/configuration/grouprefundtravel.js'
import GroupRefundTravelForms from './grouprefundtravel-form.js'

import GroupRepository from '@/shared/http/repositories/access/group'

export default {
  name: 'GroupRefundTravel',
  mixins: [ActionsForm],
  data () {
    return {
      data: GroupRefundTravelModel,
      form: GroupRefundTravelForms,
      gruposDisponiveisDB: [],
      gruposDisponiveisIds: [],
      gruposDisponiveis: [],
      gruposSelecionados: [],
      gruposSelecionadosIds: [],
      erroGrupos: false
    }
  },
  mounted () {
    loading.push()
    GroupRepository.GetAll()
      .then((response) => {
        this.gruposDisponiveisDB = response.data.data.map(g => ({
          value: g.id,
          text: g.nome
        }))
        this.gruposDisponiveis = [...this.gruposDisponiveisDB]
        loading.close()
      })
      .catch((err) => {
        loading.close()
        this.onException(err)
      })
  },
  computed: {
  },
  methods: {
    onLoad () {
      GroupRefundTravelRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onSelect (obj) {
      GroupRefundTravelRepository.GetById(obj.id)
        .then((response) => {
          this.data = response.data.data
          this.$refs.txtGroupName.focus()
          this.onEdit(this.data)
          this.gruposSelecionados = this.data.itens.map(item => ({
            value: item.grupoID,
            text: this.getGroupNameById(item.grupoID)
          }))
          this.gruposDisponiveis = this.gruposDisponiveisDB.filter(
            g => !this.gruposSelecionados.some(sel => sel.value === g.value)
          )
          this.gruposSelecionadosIds = []
          this.gruposDisponiveisIds = []
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onCreate () {
      this.erroGrupos = this.gruposSelecionados.length === 0
      if (this.erroGrupos) return
      loading.push()
      this.data.itens = this.gruposSelecionados.map(g => ({
        grupoID: g.value
      }))
      GroupRefundTravelRepository.Create(this.data)
        .then((response) => {
          this.onResult(response)
          this.gruposSelecionadosIds = []
        })
        .catch(this.onException)
    },
    onUpdate () {
      this.erroGrupos = this.gruposSelecionados.length === 0
      if (this.erroGrupos) return
      loading.push()
      this.data.status = parseInt(this.data.status)
      this.data.itens = this.gruposSelecionados.map(g => ({
        grupoID: g.value
      }))
      GroupRefundTravelRepository.Update(this.data)
        .then(this.onResult)
        .catch(this.onException)
    },
    onDelete (obj) {
      loading.push()
      GroupRefundTravelRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
          this.gruposSelecionadosIds = []
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onRemoveGroups () {
      const removidos = this.gruposSelecionados.filter(g =>
        this.gruposSelecionadosIds.includes(g.value)
      )
      this.gruposDisponiveis.push(...removidos)
      this.gruposSelecionados = this.gruposSelecionados.filter(g =>
        !this.gruposSelecionadosIds.includes(g.value)
      )
      this.gruposSelecionadosIds = []
    },
    onAddGroups () {
      const adicionados = this.gruposDisponiveis.filter(g =>
        this.gruposDisponiveisIds.includes(g.value)
      )
      this.gruposSelecionados.push(...adicionados)
      this.gruposDisponiveis = this.gruposDisponiveis.filter(g =>
        !this.gruposDisponiveisIds.includes(g.value)
      )
      this.gruposDisponiveisIds = []
    },
    getGroupNameById (id) {
      return this.gruposDisponiveisDB.find(g => g.value === id).text
    },
    onClear () {
      ActionsForm.methods.onClear.call(this)
      this.gruposDisponiveisIds = []
      this.gruposDisponiveis = [...this.gruposDisponiveisDB]
      this.gruposSelecionados = []
      this.gruposSelecionadosIds = []
      this.erroGrupos = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/grouprefundtravel/grouprefundtravel.js